import { collection, addDoc, Timestamp } from 'firebase/firestore';

import { db } from './config';
import type { HubRequest } from '@shared/types/partner';

/**
 * Create a hub request in Firestore
 */
export async function createHubRequest(
  requestData: Omit<HubRequest, 'id' | 'submittedAt' | 'createdAt' | 'updatedAt'> & {
    submittedAt?: Date;
  }
): Promise<string> {
  const hubRequestRef = collection(db, 'hub_requests');
  
  const docData = {
    ...requestData,
    submittedAt: requestData.submittedAt 
      ? Timestamp.fromDate(requestData.submittedAt)
      : Timestamp.now(),
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  };

  const docRef = await addDoc(hubRequestRef, docData);
  return docRef.id;
}

